import React from "react";
import { Info } from "lucide-react";

const SafetyAnalysis = ({
  selectedStock,
  calculateSafetyRating,
  handleMouseEnter,
  handleMouseLeave,
}) => {
  return (
    <div className="safety-analysis">
      <h4>Margin of Safety Analysis</h4>
      <div className="safety-rating-breakdown">
        <div className="safety-score">
          <div className="safety-score-circle">
            <span>{calculateSafetyRating(selectedStock)}</span>
          </div>
          <div className="safety-label">Safety Rating</div>
        </div>

        <div className="safety-factors">
          <div className="safety-factor">
            <label>
              Discount to Value
              <span
                className="info-icon"
                onMouseEnter={(e) =>
                  handleMouseEnter(
                    "Higher discounts increase margin of safety",
                    e
                  )
                }
                onMouseLeave={handleMouseLeave}
              >
                <Info size={16} />
              </span>
            </label>
            <div className="factor-bar-container">
              <div
                className="factor-bar"
                style={{
                  width: `${
                    ((selectedStock.intrinsicValue -
                      selectedStock.currentPrice) /
                      selectedStock.intrinsicValue) *
                    100
                  }%`,
                }}
              ></div>
            </div>
          </div>

          <div className="safety-factor">
            <label>
              Economic Moat
              <span
                className="info-icon"
                onMouseEnter={(e) =>
                  handleMouseEnter(
                    "Competitive advantages that protect market share",
                    e
                  )
                }
                onMouseLeave={handleMouseLeave}
              >
                <Info size={16} />
              </span>
            </label>
            <div className="factor-bar-container">
              <div
                className="factor-bar"
                style={{
                  width: `${selectedStock.economicMoat * 20}%`,
                }}
              ></div>
            </div>
          </div>

          <div className="safety-factor">
            <label>
              Financial Health
              <span
                className="info-icon"
                onMouseEnter={(e) =>
                  handleMouseEnter("Balance sheet strength and debt levels", e)
                }
                onMouseLeave={handleMouseLeave}
              >
                <Info size={16} />
              </span>
            </label>
            <div className="factor-bar-container">
              <div
                className="factor-bar"
                style={{
                  width: `${
                    (1 - selectedStock.debtToEquity) * 100 > 100
                      ? 100
                      : (1 - selectedStock.debtToEquity) * 100
                  }%`,
                }}
              ></div>
            </div>
          </div>

          <div className="safety-factor">
            <label>
              Earnings Stability
              <span
                className="info-icon"
                onMouseEnter={(e) =>
                  handleMouseEnter(
                    "Consistency and predictability of earnings",
                    e
                  )
                }
                onMouseLeave={handleMouseLeave}
              >
                <Info size={16} />
              </span>
            </label>
            <div className="factor-bar-container">
              <div
                className="factor-bar"
                style={{
                  width: `${selectedStock.earningsStability * 100}%`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyAnalysis;
